<template>
	<nav class="breadcrumbs" v-if="currentStep < steps.length+1">
		<div v-for="step in steps" @click.prevent="nextStep(step.id)" class="breadcrumbs__item" :class="{'active' : currentStep === step.id}">
			<div class="step-container">
				<div class="step-box"  :class="(currentStep === step.id ? 'is-breadcrumbs-selected' : 'is-breadcrumbs-unselected')">
					<b>{{step.id}}</b>
				</div>
				<span class="info" :class="{'is-hidden-touch' : currentStep !== step.id}">{{step.title}}</span>
			</div>

		</div>
	</nav>
</template>

<script>
export default {
	props: {
		steps: {
			type: Array,
			required : false,
			default : [
				{id:1, title:'Company info'},
			]
		},
		currentStep: {
			type : Number,
			required : false,
			default : 1
		},
		nextStep : {
			type : Function,
			required : false,
			default : (key) => {this.currentStep = key}
		},
	},

	data: function()
	{
		return {
		}
	},
	computed:
	{
		itemWidth()
		{
			var width = (100 / this.steps.length) + '%'
			return { width : width}
		}
	}
}
</script>

<style lang="sass" scoped>
	.info
		width: 115px
		height: 12.4px
		flex-grow: 0
		font-size: 17px
		font-weight: bold
		font-stretch: normal
		font-style: normal
		line-height: 1.41
		letter-spacing: normal
		text-align: left
		vertical-align: super
	.step-container
		white-space: nowrap
		padding-left: 4px
</style>

